import React from 'react';
import UiContent from '../../Components/Common/UiContent';
import BreadCrumb from '../../Components/Common/BreadCrumb';
import { Container } from 'reactstrap';
import WaterRigthsList from './WaterRigthsList';
import {Icons} from '../../utils/Icons';

const WaterRights = () => {
	const breadcrumbLinks = [
		{ to: '#', label: 'Inicio', icon: Icons.house },
		{ to: '#', label: 'Medio Ambiente', icon: Icons.environment },
		{ to: '/water-rights/list', label: 'Derechos de Agua', icon: Icons.water },
	];

	return (
		<React.Fragment>
			<UiContent />
			<div className='page-content'>
				<Container fluid>
					<BreadCrumb title='Derecho de Agua Realizadas' links={breadcrumbLinks} icon={Icons.layoutGrid} />
					<WaterRigthsList/>
				</Container>
			</div>
		</React.Fragment>
	);
};

export default WaterRights;